// extracted by mini-css-extract-plugin
export default {"bc":"BCrumb_bc__Yaxwa","option":"BCrumb_option__-2AvS","active":"BCrumb_active__PEnY6"};